import styled from 'styled-components';

export const SandTableMapContainer = styled.div`
  .amap-marker-label {
    padding: 0;
    background-color: transparent;
    border: 0;
    color: #1a1a1a;
  }
`;
